import { z } from "zod"

export enum NoteType {
  LESSON_PLAN = "LESSON_PLAN",
  GOALS = "GOALS",
  STIMULUS = "STIMULUS",
  LOGISTICS = "LOGISTICS",
  WHITEBOARD_BRIEF = "WHITEBOARD_BRIEF",
  OTHER = "OTHER",
}

export type CoachNoteDraft = {
  id: string | null
  note: string
  noteType: NoteType
  durationInMin?: number
}

export type CoachNote = {
  id: string
  note: string
  noteType: NoteType
  durationInMin?: number
}

export const CoachNoteDtoSchema = z.object({
  id: z.string(),
  note: z.string(),
  noteType: z.nativeEnum(NoteType),
  durationInMin: z.number().nullish(),
})

export type CoachNoteDto = z.infer<typeof CoachNoteDtoSchema>

export const CoachNoteDraftDtoSchema = z.object({
  id: z.string().nullable(),
  note: z.string(),
  noteType: z.nativeEnum(NoteType),
  durationInMin: z.number().nullish(),
})
export type CoachNoteDraftDto = z.infer<typeof CoachNoteDraftDtoSchema>

export type AthleteNoteDraft = {
  id: string | null
  note: string
}

export type AthleteNote = {
  id: string
  note: string
}

export const AthleteNoteDtoSchema = z.object({
  id: z.string(),
  note: z.string(),
})

export type AthleteNoteDto = z.infer<typeof AthleteNoteDtoSchema>

export const AthleteNoteDraftDtoSchema = z.object({
  id: z.string().nullable(),
  note: z.string(),
})
export type AthleteNoteDraftDto = z.infer<typeof AthleteNoteDraftDtoSchema>
